import React from "react";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { actionCreators } from "../redux/noVisitAfterFirstVisitSagas";

const NoVisitAfterFirstVisitChart = () => {
  const dispatch = useDispatch();

  const { chartData: { data_table: { cols = [], rows = [] } = {}, options } = {}, table_view } =
    useSelector((state) => {
      const {
        chartData,
        selectedFilters: { table_view }
      } = state.noVisitAfterFirstVisit;
      return {
        chartData,
        table_view
      };
    }, shallowEqual);

  const switchView = (view) => dispatch(actionCreators.updateTableView(view));

  return (
    <GoogleChart
      chartName="clients_not_returning_after_first_visit_chart"
      width="1350px"
      height={400}
      chartType={table_view ? "Table" : "AreaChart"}
      isTableView={table_view}
      enableEventListeners
      showAdditionTooltip={false}
      rows={rows}
      columns={cols}
      options={options}
      switchView={switchView}
    />
  );
};

export default NoVisitAfterFirstVisitChart;
